const fixedContent =
  'This agreement will be governed in all respects by the law of <GOVERNING LAW STATE>' +
  ' applicable to contracts performed entirely within that <STATE_PREFIX>, without regard for its conflicts of' +
  ' laws provisions.';

export default (options) => {
  let checked = false;
  let content = '';

  if (options.field1) {
    if (options.field1 === 'extra_region') {
      content = fixedContent.replace(
        '<GOVERNING LAW STATE>',
        `<i><u>&nbsp;&nbsp;select a region&nbsp;&nbsp;</u></i>`
      );
      content = content.replace('<STATE_PREFIX>', 'region');
    } else {
      content = fixedContent.replace('<GOVERNING LAW STATE>', options.field1);
      if (options.type === 'region') {
        content = content.replace('<STATE_PREFIX>', 'region');
      } else {
        content = content.replace('<STATE_PREFIX>', 'state');
      }
      checked = true;
    }
  } else {
    content = fixedContent.replace(
      '<GOVERNING LAW STATE>',
      `<i><u>&nbsp;&nbsp;select a state&nbsp;&nbsp;</u></i>`
    );
    content = content.replace('<STATE_PREFIX>', 'state');
  }

  return {
    content,
    checked,
  };
};



// WEBPACK FOOTER //
// src/components/ContractBlock/Contents/GoverningLaw.js